module.exports = __webpack_public_path__ + "img/perforaciones_9-16_810.fea45a23.webp";